export const callCenterPhoneNumber = `tel:+611300363688`

export const callCenterPhoneNumberText = '1300\u00A036\u00A036\u00A088' //unicode to prevent wrap around

export const callCenterInternationalPhoneNumber = 'tel:+61894455391'

export const callCenterInternationalPhoneNumberText = '+61\u00A08\u00A09445\u00A05391' //unicode to prevent wrap around
